import { UserRole } from '../types/user.types';

// Which statuses belong to each role's work queue.
// SECRETARIA sees "Análise de demanda aprovada" only for Direta transfers (filtered in useMemo).
// CONVENIOS sees "Análise de demanda aprovada" only for Indireta transfers (filtered in useMemo).
export const STATUS_POR_ROLE: Partial<Record<UserRole, string[]>> = {
  [UserRole.ORCAMENTO]: [
    'Recebido',
    'Em análise de admissibilidade',
    'Admissibilidade aprovada',
    // Retornos aguardando a devolução formal do Orçamento à Câmara.
    'Retornada ao Orçamento (demanda)',
    'Retornada ao Orçamento (documental)',
    'Devolvida por incompatibilidade de demanda',
    'Devolvida ao legislativo',
    'Devolvida por inviabilidade documental',
    'Devolvido',
  ],
  [UserRole.SECRETARIA]: [
    'Admissibilidade aprovada',
    'Em análise de demanda',
    'Análise de demanda aprovada',
  ],
  [UserRole.CONVENIOS]: [
    'Análise de demanda aprovada',
    'Em análise documental',
    'Análise documental aprovada',
    'Devolvida por inviabilidade documental',
  ],
  [UserRole.JURIDICO]: [
    'Em análise documental',
    'Análise documental aprovada',
  ],
  [UserRole.OPERADOR]: [
    'Iniciado',
    'Em execução',
    'Devolvido',
    'Devolvida por incompatibilidade de demanda',
    'Devolvida por inviabilidade documental',
  ],
};
